import { Typography } from 'antd';
import { FC } from 'react';

import { BRAND_COLORS } from '../../../../constants/styles';
import { TrendDirection } from '../../types';
import { TrendIndicator } from '../TrendIndicator';

const { Text } = Typography;

const CELL_STYLE = {
  textAlign: 'center' as const,
  background: BRAND_COLORS.primary.royalBlue,
  border: `1px solid ${BRAND_COLORS.secondary.steelBlue}`,
  borderRadius: 4,
  padding: '10px 16px',
};
const LABEL_STYLE = {
  color: BRAND_COLORS.secondary.lightSage,
  fontSize: 11,
} as const;
const VALUE_STYLE = {
  color: '#fff',
  fontSize: 22,
  fontWeight: 700,
  lineHeight: 1,
} as const;

interface ITrend {
  direction: TrendDirection;
  color: string;
  label: string;
}

export interface IMetricCellConfig {
  label: string;
  value: string;
  loading: boolean;
  trend?: ITrend;
  action: React.ReactNode;
}

const MetricCell: FC<IMetricCellConfig> = ({
  label,
  value,
  loading,
  trend,
  action,
}) => (
  <div style={CELL_STYLE}>
    <Text style={LABEL_STYLE}>{label}</Text>
    {trend ? (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 6,
          whiteSpace: 'nowrap',
        }}
      >
        <span style={VALUE_STYLE}>{loading ? '...' : value}</span>
        <TrendIndicator {...trend} />
      </div>
    ) : (
      <span style={{ display: 'block', ...VALUE_STYLE }}>
        {loading ? '...' : value}
      </span>
    )}
    <div style={{ marginTop: 6 }}>{action}</div>
  </div>
);

export const PipelineMetricsStrip: FC<{
  contentWidth: number;
  cells: IMetricCellConfig[];
}> = ({ contentWidth, cells }) => (
  <div
    style={{
      display: 'grid',
      gridTemplateColumns:
        contentWidth < 600
          ? 'repeat(1, 1fr)'
          : contentWidth < 950
          ? 'repeat(2, 1fr)'
          : 'repeat(3, 1fr)',
      gap: 8,
      background: BRAND_COLORS.primary.deepNavy,
      borderRadius: 8,
      padding: '8px 16px',
      marginBottom: 24,
    }}
  >
    {cells.map((cell) => (
      <MetricCell key={cell.label} {...cell} />
    ))}
  </div>
);
